import { useQuery } from "react-query";
import API from "../../axios/API";
import { QUERY_KEYS } from "../keys";
import { GET_ENDPOINTS } from "@/axios/API/endpoints";

const getTeams = async () => {
  const { data } = await API.get(GET_ENDPOINTS.TEAMS);
  return data;
};

const useTeams = () => useQuery(QUERY_KEYS.TEAMS, getTeams);

export default useTeams;
